import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {handleCupola, } from "../../../action/index.js";

const NumberInput = ({ type }) => {
    const dispatch = useDispatch();
    const const_var = useSelector(state => state.reducer.const_var);
    const [value, setValue] = useState(0);

    const handleMinusClick = () => {    
        if(const_var.cupolaEntries != undefined && const_var.cupolaEntries.length > 0) {
            dispatch(handleCupola(type, 'remove', '','fromOptionTab'));
        }  
    }

    const handlePlusClick = () => {
        dispatch(handleCupola(type, 'add'));
    }

    useEffect(() => {
        let count = 0;
        const_var.cupolas.forEach((cupola) => {
            if (cupola.userData && cupola.userData.editIconPos && cupola.userData.compType === type) {
                count++;
            }
        })
        setValue(count);
    })

    return (
        <div className="number-input">
            <i className='icon-minus' style={{color: (value=="0" && '#999999')}} onClick={() =>handleMinusClick()}></i>
            <input
                value={value}
                min="0"
                type="number"
                style={{color: (value=="0" && '#999999')}}
            />
            <i className='icon-plus' onClick={() => handlePlusClick()}></i>
        </div>
    );
}

export default NumberInput;